import { render, staticRenderFns } from "./PhotoGroupComponent.vue?vue&type=template&id=1f60ebe0"
import script from "./PhotoGroupComponent.vue?vue&type=script&lang=js"
export * from "./PhotoGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports